<div class="content">
    <div class="title">Do you want to continue?</div>
    <div id="logout-desc" class="message">You will be logged out in {{modalCountDisplay}} minutes</div>
    <div class="message">Your progress may not be saved</div>
</div>
<div class="button-container">
    <button type="button" mat-raised-button color="white" type="button"
        (click)="dialogRef.close('logout')">LOG OUT</button>
    <button type="button" mat-raised-button color="primary" type="button"
        (click)="dialogRef.close('stay')">CONTINUE</button>
</div>